import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getStoresApi } from '../../../utils/apis';
import { useUser } from '../../../hooks/useUser';

const EMPTY_STORES: any[] = [];

export const useStores = (page = 0, pageSize = 100) => {
  const { user } = useUser();
  const {
    data,
    isPending,
    isLoading,
    isFetching,
    isRefetching,
    isError,
    error,
  } = useQuery({
    queryKey: ['stores', user?.tenantName, page, pageSize],
    queryFn: () => getStoresApi(user?.tenantName || '', page, pageSize),
    gcTime: 1000 * 60 * 30,
    staleTime: Infinity,
    enabled: !!user?.tenantName,
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  // Consider all loading states to show skeleton
  const storesListLoading =
    isPending || isLoading || isFetching || isRefetching;
  const storesData = data;
  const storesList = useMemo(
    () => data?.data?.stores || EMPTY_STORES,
    [data?.data?.stores]
  );
  const isStoresListError = isError;
  const storesListError = error;
  return {
    storesData,
    storesList,
    storesListLoading,
    isStoresListError,
    storesListError,
  };
};
